import styled from "styled-components";

export const SelectorTitle = styled.div`
  font-weight: bold;
  margin: 20px 10px;
`;

export const SelectorName = styled.div`
  font-weight: 600;
`;

export const SelectorTitleWithButton = styled.div`
  font-weight: bold;
  margin: 20px 10px;
  display: flex;
  justify-content: space-between;
`;

export const SelectorTitleButton = styled.div`
  font-weight: normal;
  font-size: 13px;
  cursor: pointer;
`;

export const SelectorInputOption = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 20px 15px;
  background-color: white;
  border-bottom: 0.5px solid ${(props) => props.theme.sepColor};
  &:last-child {
    margin-bottom: 0;
  }

  input {
    margin-top: -3px;
    width: 25px;
    height: 25px;
    accent-color: ${(props) => props.theme.smalt};
  }
`;

export const Fixture = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const TeamsBadge = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 15px;

  img {
    width: 20px;
  }
`;

export const FixtureDate = styled.div`
  font-size: 13px;
`;

export const NoFixture = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const StickyButtonContainer = styled.div`
  border-top: 1px dotted ${(props) => props.theme.hrColor};
  background-color: ${({ theme }) => theme.white};
  padding: 16px;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const StickyButton = styled.button`
  background-color: ${(props) => props.theme.smalt};
  color: ${(props) => props.theme.white};
  width: 100%;
  margin: auto auto 0;
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
  font-weight: bold;
  height: 40px;
  border: none;
  border-radius: 4px;
`;